import styled from 'styled-components';

export const StyledFindLeads = styled.div`
  width: 100%;
  min-height: calc(100vh - 50px);
  padding: 16px;
  border-radius: 16px;
  border: 1px solid rgba(157, 157, 157, 0.3);
  background: var(--white);
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;

  .content-holder {
    width: 100%;
    max-width: 650px;
  }

  .head {
    display: flex;
    align-items: flex-start;
    gap: 10px;
    text-align: center;
    margin: 0 0 30px;

    > div {
      width: 100%;
    }
    .heading {
      display: block;
      font-size: 25px;
      line-height: 30px;
      font-weight: 700;
      color: var(--text-color-50);
      text-align: center;
      margin: 0 0 10px;
    }

    .text {
      display: block;
    }
  }

  .card-title {
    display: block;
    font-size: 18px;
    line-height: 22px;
    font-weight: 400;
    font-style: italic;
    color: var(--text-color-50);
    margin: 0 0 15px;
  }

  .tabs-btns {
    display: flex;
    gap: 10px;
    margin-bottom: 20px;

    .tabBtn {
      width: 50%;
      padding: 1px;
      border-radius: 20px;
      border: 1px solid rgba(226, 226, 226, 0.5);
      background: #fafafa;

      .btn-content {
        position: relative;
        display: flex;
        align-items: center;
        gap: 15px;
        padding: 17px;
        border-radius: 10px;
        text-align: left;
      }

      &.active {
        .ico-tick {
          border: 1.5px solid var(--primary);

          img {
            display: block;
          }
        }
      }
    }

    .ico-tick {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 20px;
      height: 20px;
      border-radius: 50px;
      border: 1.5px solid #cacaca;

      img {
        display: none;
        width: 11px;
        height: auto;
      }
    }

    .icon-box {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 40px;
      height: 40px;
      border-radius: 50px;
      border: 1px solid #efefef;
      background: var(--white);
      color: #0077b5;
    }

    .text-box {
      flex-grow: 1;

      .subtitle {
        display: block;
        font-size: 12px;
        line-height: 14px;
        margin: 0 0 6px;
      }
      .title {
        display: block;
        font-size: 14px;
        line-height: 18px;
        font-weight: 700;
        margin: 0;
      }
    }
  }

  .input-holder {
    display: flex;
    gap: 16px;

    .url-input {
      input {
        width: 360px;
      }
    }
  }

  .note {
    display: block;
    font-size: 14px;
    line-height: 18px;
    margin: 0 0 30px;

    .heading {
      color: var(--danger);
    }
  }

  .btn-holder {
    display: flex;
    justify-content: center;
  }
`;
